// src/store/store.js (Assume this structure)

import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { adminApi } from "../redux/admin/adminApi";
import { groupAdminApi } from "../redux/groupAdminApi";
import { creditsApi } from "../redux/admin/creditsApi";
import { dashboardApi } from "../redux/admin/dashboardApi";
import { logisticsApi } from "../redux/logistics/logisticsApi";
import { taskApi } from "../redux/admin/taskApi";
import { groupApi } from "../redux/admin/groupApi";
import { userApi } from "../redux/admin/userApi";
import { alarmApi } from "../redux/admin/alarmApi";
import { cameraApi } from "../redux/admin/cameraApi";
import { streamApi } from "../redux/admin/streamApi";
import { screenshotApi } from "../redux/admin/screenshotApi";
import { protocolApi } from "../redux/protocol/protocolApi";
import { historyApi } from "../redux/admin/historyApi";
import { reportApi } from "../redux/admin/reportApi";
import { deviceApi } from "../redux/admin/deviceApi";
import { inventoryApi } from "../redux/admin/inventoryApi";
import { jt808Api } from "../redux/admin/jt808Api";
import { rechargePlanApi } from "../redux/admin/rechargePlanApi";
import { supportTicketApi } from "../redux/admin/supportTicketApi";
import { calendarApi } from "../redux/admin/calendarApi";
import { crudSyncMiddleware } from "./crudSync";





export const store = configureStore({
  reducer: {
    auth: authReducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [groupAdminApi.reducerPath]: groupAdminApi.reducer, // <<< FIX 1: Add groupAdminApi reducer
    [creditsApi.reducerPath]: creditsApi.reducer, // <<< FIX 3: Add creditsApi reducer
    [dashboardApi.reducerPath]: dashboardApi.reducer, // <<< FIX 5: Add dashboardApi reducer
    [logisticsApi.reducerPath]: logisticsApi.reducer, // <<< NEW: Add logisticsApi reducer
    [taskApi.reducerPath]: taskApi.reducer,
    [groupApi.reducerPath]: groupApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [protocolApi.reducerPath]: protocolApi.reducer,
    [alarmApi.reducerPath]: alarmApi.reducer,
    [cameraApi.reducerPath]: cameraApi.reducer,
    [streamApi.reducerPath]: streamApi.reducer,
    [screenshotApi.reducerPath]: screenshotApi.reducer,
    [alarmApi.reducerPath]: alarmApi.reducer,
    [historyApi.reducerPath]: historyApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [deviceApi.reducerPath]: deviceApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [jt808Api.reducerPath]: jt808Api.reducer,
    [rechargePlanApi.reducerPath]: rechargePlanApi.reducer,
    [supportTicketApi.reducerPath]: supportTicketApi.reducer,
    [calendarApi.reducerPath]: calendarApi.reducer,



  },
  // Adding the api middleware enables caching, invalidation, polling, etc.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      crudSyncMiddleware,
      adminApi.middleware,
      groupAdminApi.middleware, // <<< FIX 2: Add groupAdminApi middleware
      creditsApi.middleware, // <<< FIX 4: Add creditsApi middleware
      dashboardApi.middleware, // <<< FIX 6: Add dashboardApi middleware
      logisticsApi.middleware, // <<< NEW: Add logisticsApi middleware
      taskApi.middleware ,// <<< NEW: Add taskApi middleware
      groupApi.middleware ,
      userApi.middleware,
      protocolApi.middleware,
      alarmApi.middleware,
      cameraApi.middleware,
      screenshotApi.middleware,
      streamApi.middleware,
      historyApi.middleware,
      reportApi.middleware,
      deviceApi.middleware,
      inventoryApi.middleware,
      jt808Api.middleware,
      rechargePlanApi.middleware,
      supportTicketApi.middleware,
      calendarApi.middleware,
   
    ),
});
